module.exports = __webpack_public_path__ + "static/travel_phenomena_cover.e0172e6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/travel_phenomena_cover.jpg
// module id = 519
// module chunks = 228578108878866